var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_social_vimeo",
    "data-name": "icons / social / vimeo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.239,9.644S6.17,6.588,7.065,12.627l2.551,9.539s2.682,9.839,8.721,7.6c0,0,9.141-4.953,15.654-19.23,0,0,3.8-10.513-3.357-10.513,0,0-7.636-.762-9.618,6.066,0,0-.661,2.13,1.567,1.987,0,0,3.8-1.342,1.347,4.7,0,0-2.688,6.26-4.925,6.26,0,0-2.68.076-3.349-11.328,0,0,.157-7.417-5.657-7.417,0,0-3.515,1.08-10,8.01L2.239,9.644Z",
    transform: "translate(0 2.45)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVimeo);
export default __webpack_public_path__ + "static/media/icon_vimeo.cb6c75ff.svg";
export { ForwardRef as ReactComponent };